import TemplatePreview from './template-preview';

export default TemplatePreview;